import { Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import { DialogTitle } from '@mui/material';
import React from 'react';
import CustomButton from '../../../../../../../lib/designSystem/Button';

const CreateFolderDialog = (props: any) => {
  const {
    openCreateFolder,
    setOpenCreateFolder,
    handleCreateFolder,
    folderName,
    setFolderName,
  } = props;
  return (
    <Dialog
      open={openCreateFolder}
      onClose={() => {
        setOpenCreateFolder(false);
        setFolderName('');
      }}
    >
      <DialogTitle>Crear carpeta</DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: '10px' }}>
          <TextField
            label="Nombre de la carpeta"
            variant="outlined"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            fullWidth
          />
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => {
            setOpenCreateFolder(false);
            setFolderName('');
          }}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleCreateFolder} color="primary">
          Crear
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFolderDialog;
